export default class Nav {
    constructor() {

        this.open = {
            nav: false,
            newsletter: false,
        }

        const toggles = [...document.querySelectorAll('.toggle')];

        this.modalInTransition = false;
        this.closeNewsletterModal = this.closeNewsletterModal.bind(this);

        toggles.forEach(toggle => toggle.addEventListener('click', this.toggle.bind(this)));

        const anchorToggles = [...document.querySelectorAll('[href="#newsletter"]')];

        if (anchorToggles.length) {
            anchorToggles.forEach(toggle => toggle.addEventListener('click', (event) => {
                event.preventDefault();
                this.showNewsletter(true)
            }));
        }

        this.searchForm = document.querySelector('[type="search"]');
        this.searchForm.addEventListener('keyup', (event) => {
            if (event.keyCode === 27) {
                this.searchFocusHandler(false);
                this.searchForm.blur();
            }
        });
        this.searchForm.addEventListener('focus', () => this.searchFocusHandler(true));
        this.searchForm.addEventListener('blur', (event) => {

            if (!event.relatedTarget) {
                this.searchFocusHandler(false);
                return;
            }

            if (event.relatedTarget.id !== 'search-submit') {
                this.searchFocusHandler(false)
            }
        });
    }

    searchFocusHandler(state) {
        document.body.classList[state ? 'add' : 'remove']('search-focus');
    }

    toggle(event) {
        const target = event.target.dataset.toggle;
        const isOpen = this.open[target];
        this[`show${target.charAt(0).toUpperCase()}${target.substr(1)}`](!isOpen);
    }

    showNav(state) {
        const f = state ? 'add' : 'remove';
        document.body.classList[f]('show-nav');
        this.open.nav = state;
    }

    showNewsletter(state) {
        const modalContent = document.querySelector('.modal-content');

        if (state) {
            document.body.classList.add('show-newsletter');

            setTimeout(() => {
                modalContent.classList.remove('opacity-0');
                modalContent.querySelector('input[type="text"]').focus();
                this.modalInTransition = false;
                window.addEventListener('click', this.closeNewsletterModal);
            }, 100);
        } else {
            this.closeNewsletterModal();
        }
    }

    closeNewsletterModal(event) {

        const elClasses = event.target.classList;

        // Only look for clicks on the background
        if (elClasses.contains('newsletter-modal') || elClasses.contains('btn-close')) {
            const modalContent = document.querySelector('.modal-content');
            modalContent.classList.add('opacity-0');
            window.removeEventListener('click', this.closeNewsletterModal);

            setTimeout(() => {
                document.body.classList.remove('show-newsletter');
                this.open[this.target] = false;
                this.modalInTransition = false;
                this.target = null;
            }, 100);
        }
    }
}